/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.UserList.title',
    defaultMessage: 'User Management',
  },
  publisher: {
    id: 'app.containers.UserList.publisher',
    defaultMessage: 'Publisher',
  },
  createPublisher: {
    id: 'app.containers.UserList.createPublisher',
    defaultMessage: 'Create publisher',
  },
  typeToSearch: {
    id: 'app.containers.UserList.typeToSearch',
    defaultMessage: 'Type to search ...',
  },
  noSearchResults: {
    id: 'app.containers.UserList.noSearchResults',
    defaultMessage: 'No search results found',
  },
  showDownloadMenu: {
    id: 'app.containers.UserList.showDownloadOptions',
    defaultMessage: 'Show download options',
  },
  downloadVCard: {
    id: 'app.containers.UserList.downloadVCard',
    defaultMessage: 'Download vCard',
  },
  downloadXlsx: {
    id: 'app.containers.UserList.downloadXlsx',
    defaultMessage: 'Download Excel',
  },
  downloadVCardSucceeded: {
    id: 'app.containers.UserList.downloadVCardSucceeded',
    defaultMessage: 'Successfully created vCard',
  },
  downloadVCardFailed: {
    id: 'app.containers.UserList.downloadVCardFailed',
    defaultMessage: 'Error while creating vCard',
  },
  invitePublishersSucceeded: {
    id: 'app.containers.UserList.invitePublishersSucceeded',
    defaultMessage: 'Publishers successfully invited',
  },
  invitePublishersFailed: {
    id: 'app.containers.UserList.invitePublishersFailed',
    defaultMessage: 'Error. Publishers could not be invited.',
  },
  sendPendingInvitations: {
    id: 'app.containers.UserList.sendPendingInvitations',
    defaultMessage: 'Send pending invitations',
  },
  sendingPendingInvitations: {
    id: 'app.containers.UserList.sendingPendingInvitations',
    defaultMessage: 'Sending pending invitations...',
  },
  firstName: {
    id: 'app.containers.UserList.firstName',
    defaultMessage: 'Firstname',
  },
  lastName: {
    id: 'app.containers.UserList.lastName',
    defaultMessage: 'Lastname',
  },
  email: {
    id: 'app.containers.UserList.email',
    defaultMessage: 'E-Mail',
  },
  status: {
    id: 'app.containers.UserList.status',
    defaultMessage: 'Status',
  },
  stateInactive: {
    id: 'app.containers.UserList.stateInactive',
    defaultMessage: 'Inactive',
  },
  stateInvited: {
    id: 'app.containers.UserList.stateInvited',
    defaultMessage: 'Invited',
  },
  stateLocked: {
    id: 'app.containers.UserList.stateLocked',
    defaultMessage: 'Locked',
  },
  stateActive: {
    id: 'app.containers.UserList.stateActive',
    defaultMessage: 'Active',
  },
  stateAtRiskToBecomeInactive: {
    id: 'app.containers.UserList.stateAtRiskToBecomeInactive',
    defaultMessage: 'Soon inactive.',
  },
  selectAllPublishers: {
    id: 'app.containers.UserList.selectAllPublishers',
    defaultMessage: 'Select all publishers',
  },
  selectPublisher: {
    id: 'app.containers.UserList.selectPublisher',
    defaultMessage: 'Select publisher',
  },
  inviteSelectedPublishers: {
    id: 'app.containers.UserList.inviteSelectedPublishers',
    defaultMessage: 'Invite',
  },
  sendEmailToSelectedPublishers: {
    id: 'app.containers.UserList.sendEmailToSelectedPublishers',
    defaultMessage: 'Write email',
  },
  actionForSelected: {
    id: 'app.containers.UserList.actionForSelected',
    defaultMessage: 'action for {numberOfSelectedPublishers} selected',
  },
  editPublisher: {
    id: 'app.containers.UserList.editPublisher',
    defaultMessage: 'Edit publisher',
  },
  sendEmailToAll: {
    id: 'app.components.UserList.sendEmailToAll',
    defaultMessage: 'Send Email',
  },
  numberOfResults: {
    id: 'app.components.UserList.numberOfResults',
    defaultMessage: '{numberOfResults} found',
  },
  apply: {
    id: 'app.components.UserList.apply',
    defaultMessage: 'Apply filters',
  },
  filter: {
    id: 'app.components.UserList.filter',
    defaultMessage: 'Filter',
  },
  filterSettings: {
    id: 'app.components.UserList.filterSettings',
    defaultMessage: 'Filter settings',
  },
});
